import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=22ca92d9&"
import script from "./Google.vue?vue&type=script&lang=js&"
export * from "./Google.vue?vue&type=script&lang=js&"
import style0 from "./Google.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports